import React, { Component } from 'react';
import ReactDataGrid from 'react-data-grid';
import { Toolbar, Data } from 'react-data-grid-addons';
import axios from 'axios';
import _ from 'lodash';
import { Field } from 'redux-form';
import classNames from 'classnames';
import { SubmissionError } from 'redux-form';
import { Grid, Row, Col, Panel, Button, Form, DropdownButton, MenuItem, InputGroup, Input } from 'react-bootstrap';
import ContentWrapper from '../Layout/ContentWrapper';
import Spinner from '../../components/Widgets/spinner';
import InputField from '../Common/inputField';
import Selection from '../Common/selection';
import ReactDOM from 'react-dom';
import { Translate, Localize } from 'react-redux-i18n';
import FilterByStart from '../Common/filterByStart';

var ESCAPE_KEY = 27;
var ENTER_KEY = 13;

class RowRenderer extends Component {
    PropTypes: {
      onDoubleClick: React.PropTypes.func
    }

    render() {
        return (<div onDoubleClick={ ()=>{ this.props.onDoubleClick(this.props.row) } } ><ReactDataGrid.Row ref="row" {...this.props} /></div>)
    }
}

class InventoryInfo extends Component {
    constructor() {
      super();
      this.state = {
        rows: [],
        sortColumn: null,
        sortDirection: null,
        clickedCell: {row: 0, column:-1}
      }
      this.onCellSelected = this.onCellSelected.bind(this);
      this.selectProduct = this.selectProduct.bind(this);
      this.handleKeyDown = this.handleKeyDown.bind(this);
      this.onKeyDown = this.onKeyDown.bind(this);
    }

    handleKeyDown(event) {
        switch( event.keyCode ) {
            case ESCAPE_KEY:
                this.props.closeShowInventory('allProducts');
                break;
            default:
                break;
        }
    }

    componentWillMount() {
      document.addEventListener("keydown", this.handleKeyDown);
    }

    componentWillUnmount() {
      document.removeEventListener("keydown", this.handleKeyDown);
    }

    componentDidMount() {
      this.props.setAllProductQuantity(1);
      if(this.props.searchForBatch) {
        this.props.fetchReturnBatch(this.props.searchType, this.props.searchValue);
      }
      else {
        this.props.fetchSimplifiedProducts(this.props.searchType, this.props.searchValue);
      }
      ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    }

    handleFormSubmit(formProps) {
    }

    componentWillReceiveProps(nextProps) {
      if(nextProps.simplifiedProducts && nextProps.simplifiedProducts != this.props.simplifiedProducts) {
        var rows = [...nextProps.simplifiedProducts];
        this.setState({rows});
      }
    }

    // componentDidUpdate(prevProps, prevState) {
    //   if(prevProps.simplifiedProducts && prevProps.simplifiedProducts.length != 0 && prevProps.simplifiedProducts != this.props.simplifiedProducts) {
    //     console.log(this.refs["inventoryInfo"], "2", prevProps.simplifiedProducts, this.props.simplifiedProducts )
    //     ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    //   }
    //   // if( (!(prevProps.simplifiedProducts) || (prevProps.simplifiedProducts.length==0)) && this.props.simplifiedProducts && this.props.simplifiedProducts.length != 0) {
    //   //   ReactDOM.findDOMNode(this.refs["inventoryInfo"].refs.base.refs.viewPortContainer).focus();
    //   // }
    // }

    onCellSelected(coordinates) {
        var clickedCell = {
            row: coordinates.rowIdx,
            column: coordinates.idx - 1
            // because there is a checkbox column makes this 1 indexed, convert it to 0 indexed here
        };
        this.setState({clickedCell});
    }

    onKeyDown(e) {
         if (e.keyCode === ENTER_KEY) {
            e.preventDefault();
            var rows = this.state.rows;
            var row = rows[this.state.clickedCell.row];
            this.selectProduct(row)
            // this.props.selectInventoryInfo(row);
            // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
            // this.props.closeShowInventory('allProd_Quantity');
          }
      }


    selectProduct(product) {
      this.props.selectInventoryInfo(product);
      this.props.setAllProducts(`${product.ProductNum} | ${product.Name} | ${product.Description} | ${product.MeasureUnit}`, this.props.form );
      this.props.closeShowInventory('allProd_Quantity');
    }

    renderTable() {
        if (this.props.simplifiedProductsIsLoading && !this.props.simplifiedProductsError) return <Spinner/>
        else if (this.props.simplifiedProductsError) return <ContentWrapper><div className="alert alert-danger">{JSON.stringify(this.props.simplifiedProductsError)}</div></ContentWrapper>
        else {
            // Parameters of the react-data-grid

            const getRows = () => {
                return Data.Selectors.getRows(this.state);
            }

            const getSize = () => {
                return getRows().length;
            }

            const rowGetter = rowIdx => {
                var rows = getRows();
                return rows[rowIdx];
            }

            // Handle the sortable function

            const handleGridSort = (sortColumn, sortDirection) => {
                var state = Object.assign({}, this.state, { sortColumn: sortColumn, sortDirection: sortDirection });
                this.setState(state);
            }

            // Handle the row select function

            const onRowSelect = rows => {
                this.setState({ selectedRows: rows });
            }

            // const onKeyDown = (e) => {
            //    if (e.keyCode === ENTER_KEY) {
            //       e.preventDefault();
            //       var rows = this.state.rows;
            //       var row = rows[this.state.clickedCell.row];
            //       this.selectProduct(row)
            //       // this.props.selectInventoryInfo(row);
            //       // this.props.setAllProducts(`${row.ProductNum} | ${row.Name} | ${row.Description} | ${row.MeasureUnit}`, 'purchaseOrderForm');
            //       // this.props.closeShowInventory('allProd_Quantity');
            //     }
            // }


            // Column difinition

            const columns = [
              {
                  key: 'ProductNum',
                  name: <Translate value="prod_num" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterRenderer: FilterByStart,
              },
              {
                  key: 'RefNum',
                  name: <Translate value="ref_num" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
                  filterRenderer: FilterByStart,
              },
              {
                  key: 'Name',
                  name: <Translate value="prod_name" />,
                  resizable: true,
                  sortable: true,
                  width: 200,
              },
              {
                  key: 'Description',
                  name: <Translate value="desc" />,
                  resizable: true,
                  sortable: true,
              },
              {
                  key: 'ProductCost',
                  name: <Translate value="unit_dollarsign" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
              },
              {
                  key: 'MeasureUnit',
                  name: <Translate value="pkg_type" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
                  filterable: true
              },
              {
                  key: 'PackageType',
                  name: <Translate value="package_size" />,
                  resizable: true,
                  sortable: true,
                  width: 70,
              },
              {
                  key: 'InStock',
                  name: <Translate value="instock" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
              },
              {
                  key: 'Purchased',
                  name: <Translate value="purchased" />,
                  resizable: true,
                  sortable: true,
                  width: 100,
              },
              {
                  key: 'PreSale',
                  name: <Translate value="presale" />,
                  resizable: true,
                  sortable: true,
                  width: 80,
              },
            ]

            return (
                <Row><Col sm={ 12 }><div id="InventoryInfo-dataGrid1">
                    <ReactDataGrid
                        ref="inventoryInfo"
                        rowRenderer={<RowRenderer onDoubleClick={this.selectProduct} />}
                        rowKey='Product_id'
                        rowHeight={25}
                        minHeight={600}
                        onGridSort={handleGridSort}
                        columns={columns}
                        rowGetter={rowGetter}
                        rowsCount={getSize() }
                        enableCellSelect={true}
                        onGridKeyDown={this.onKeyDown}
                        onCellSelected={this.onCellSelected}
                    />
                </div></Col></Row>
            )
        }
    }

    render() {
        return (
            <ContentWrapper>
              { this.renderTable() }
            </ContentWrapper>
        )
    }
}

export default InventoryInfo



// WEBPACK FOOTER //
// ./master/jsx/components/Purchase/inventoryInfo.jsx